import * as React from "react";
import { forwardRef, memo } from "react";
const SvgAm = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 6 3", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#F2A800", d: "M0 0h6v3H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#0033A0", d: "M0 0h6v2H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#D90012", d: "M0 0h6v1H0z" }));
const ForwardRef = forwardRef(SvgAm);
const Memo = memo(ForwardRef);
export default Memo;
